import React from 'react'
import Dropdown from 'react-bootstrap/Dropdown'

export class LoginLink extends React.Component {
  constructor(props) {
    super(props)
    this.state = { username: null }
  }

  componentDidMount() {
    fetch(this.props.loginCheckUrl, { credentials: 'same-origin', redirect: 'manual' })
      .then(response       => response.json())
      .then(json           => this.handleLoginCheck(json))
      .then(undefined, err => null)
  }

  handleLoginCheck = (body) => {
    this.setState(body)
  }

  render() {
    if (this.state.username) {
      let links = this.state.links.map(
        (link, index) => <MenuItem key={index} link={link} />
      )

      return <Dropdown alignRight id='header-login-dropdown'>
        <Dropdown.Toggle as='a' className='header-link' href='#' id='header-login-dropdown-toggle'>
          <img className='header-login-image' src={this.state.avatar_url} alt={this.state.name} />
          <span className='header-login-label'>{ I18n.t('layouts.header.my_profile') }</span>
          <span className='header-login-caret'></span>
        </Dropdown.Toggle>

        <Dropdown.Menu className='dropdown-menu'>{links}</Dropdown.Menu>
      </Dropdown>
    } else {
      return <a href={ this.props.loginUrl } className='header-link'>
        <span className='header-login-icon'><i className="fa fa-user-circle fa-fw"></i></span>
        <span className='header-login-label'>{ I18n.t('layouts.header.login') }</span>
      </a>
    }
  }
}

class MenuItem extends React.Component {
  render() {
    if (this.props.link == 'separator') return <div role='separator' className='dropdown-divider'></div>
    return <a className='dropdown-item' href={this.props.link.href}>{this.props.link.name}</a>
  }
}
